import React from "react";
import { Youtube, FileText, Video, X } from "lucide-react";
import Field from "@/components/post-ad/Field";

/**
 * Combined media block: uploaded video (≤ 2 MB), YouTube URL and up to
 * three PDF attachments. Kept in one file because these three fields
 * always appear together in the founder's spec and share the same visual
 * rhythm.
 */
export default function MediaSection({ form, set, uploadVideo, uploadDoc, maxDocs }) {
  return (
    <>
      <Field
        label={
          <span className="inline-flex items-center gap-1.5">
            <Video className="w-3.5 h-3.5" /> Video (optional, ≤ 2 MB)
          </span>
        }
      >
        <div className="flex items-center gap-3">
          <label className="rounded-full px-4 py-2 bg-slate-100 hover:bg-slate-200 text-sm font-semibold cursor-pointer transition-colors">
            {form.video ? "Replace video" : "Upload video"}
            <input
              type="file"
              accept="video/*"
              className="sr-only"
              onChange={(e) => e.target.files?.[0] && uploadVideo(e.target.files[0])}
              data-testid="post-ad-video-input"
            />
          </label>
          {form.video && (
            <button
              type="button"
              onClick={() => set({ video: "" })}
              className="text-xs font-semibold text-red-500 hover:underline"
            >
              Remove
            </button>
          )}
        </div>
      </Field>

      <Field
        label={
          <span className="inline-flex items-center gap-1.5">
            <Youtube className="w-3.5 h-3.5" /> YouTube URL
          </span>
        }
      >
        <input
          data-testid="post-ad-youtube"
          value={form.youtube_url}
          onChange={(e) => set({ youtube_url: e.target.value })}
          className="input"
          placeholder="https://youtube.com/watch?v=…"
          maxLength={200}
        />
      </Field>

      <Field
        label={
          <span className="inline-flex items-center gap-1.5">
            <FileText className="w-3.5 h-3.5" /> PDF documents (up to {maxDocs}, ≤ 10 MB each)
          </span>
        }
      >
        <div className="flex flex-wrap gap-2 items-center">
          {form.documents.map((d, i) => (
            <span
              key={i}
              className="inline-flex items-center gap-1.5 rounded-full bg-slate-100 px-3 py-1.5 text-xs text-slate-700"
              data-testid={`post-ad-doc-${i}`}
            >
              <FileText className="w-3.5 h-3.5" /> {d.name}
              <button
                type="button"
                onClick={() => set({ documents: form.documents.filter((_, j) => j !== i) })}
                className="text-slate-400 hover:text-red-500"
              >
                <X className="w-3 h-3" />
              </button>
            </span>
          ))}
          {form.documents.length < maxDocs && (
            <label className="inline-flex items-center gap-1.5 rounded-full border border-dashed border-[color:var(--brand-blue)] text-[color:var(--brand-blue)] px-3 py-1.5 text-xs font-semibold cursor-pointer">
              + Add PDF
              <input
                type="file"
                accept="application/pdf"
                className="sr-only"
                onChange={(e) => e.target.files?.[0] && uploadDoc(e.target.files[0])}
                data-testid="post-ad-doc-input"
              />
            </label>
          )}
        </div>
      </Field>
    </>
  );
}
